import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
export function AuthoritySection() {
  return <section className="bg-cosmic-black relative z-10 py-12 px-6" data-id="element-42">
      <ScrollReveal className="max-w-4xl mx-auto" data-id="element-43">
        <div className="bg-cosmic-card border border-gold/20 rounded-2xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-44">
          {/* Decorative corner accents */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t border-l border-gold/40 rounded-tl-2xl" data-id="element-45"></div>
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b border-r border-gold/40 rounded-br-2xl" data-id="element-46"></div>

          <div className="flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-47">
            {/* Avatar Side */}
            <div className="w-full md:w-1/3 flex flex-col items-center text-center" data-id="element-48">
              <div className="w-40 h-40 rounded-full border-2 border-gold p-1 mb-6 relative" data-id="element-49">
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-violet/40 to-gold/20 animate-pulse" data-id="element-50"></div>
                <div className="w-full h-full rounded-full bg-cosmic-deep flex items-center justify-center overflow-hidden relative z-10" data-id="element-51">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=400&auto=format&fit=crop" alt="Lady Aristhéne" className="w-full h-full object-cover opacity-90 mix-blend-luminosity hover:mix-blend-normal transition-all duration-500" data-id="element-52" />
                </div>
              </div>
              <h3 className="font-playfair text-xl text-gold font-bold mb-1" data-id="element-53">
                Lady Aristhéne
              </h3>
              <p className="text-lunar-muted text-sm uppercase tracking-wider" data-id="element-54">
                Mystic Witch &<br data-id="element-55" />
                Sleep Strategist
              </p>
            </div>

            {/* Copy Side */}
            <div className="w-full md:w-2/3" data-id="element-56">
              <p className="text-gold uppercase tracking-widest text-xs font-semibold mb-4" data-id="element-57">
                The Origin of the Script
              </p>

              <h2 className="font-playfair text-lunar-white text-3xl md:text-4xl font-bold leading-tight mb-6" data-id="element-58">
                Created by Lady Aristhéne —<br data-id="element-59" />
                The Witch Who Decoded the
                <br data-id="element-60" />
                Sacred Sleep Portal
              </h2>

              <div className="text-lunar-lavender text-base md:text-lg leading-relaxed font-lato space-y-4" data-id="element-61">
                <p data-id="element-62">Lady Aristhéne was not always a healer.</p>

                <p data-id="element-63">
                  She was a woman who spent seven years attracting emotionally
                  unavailable men, convincing herself she simply wasn't 'the
                  type' that got chosen.
                </p>

                <p data-id="element-64">
                  Until one sleepless night, deep in research across ancient
                  feminine mysticism and modern sleep neuroscience, she
                  discovered the pattern:
                </p>

                <p className="text-lunar-white font-semibold" data-id="element-65">
                  Every woman she studied who had transformed her love life
                  radically — had done it through the sleep state.
                </p>

                <p data-id="element-66">
                  Not through force. Not through chasing. Through deep,
                  intentional subconscious reprogramming at the exact moment the
                  mind goes unguarded.
                </p>

                <p data-id="element-67">
                  She spent three years refining the script. Testing it. Living
                  it.
                </p>

                <p data-id="element-68">
                  The Midnight Magnet is the result. And it has already changed
                  the lives of thousands of women who, just like you, had almost
                  given up.
                </p>
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </section>;
}